import { render, staticRenderFns } from "./SubcrpitonPromotions.vue?vue&type=template&id=2a60bfda"
import script from "./SubcrpitonPromotions.vue?vue&type=script&lang=js"
export * from "./SubcrpitonPromotions.vue?vue&type=script&lang=js"
import style0 from "./SubcrpitonPromotions.vue?vue&type=style&index=0&id=2a60bfda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports